import ModalError from './ModalError.jsx';

export default ModalError;